import * as React from 'react';
import Grid from '@mui/material/Unstable_Grid2';

import { LabeledData } from 'components/Input';
import { formatDollar } from 'helpers/formatters';
import { Tooltip } from '@mui/material';

interface Props {
    homeState: string;
    totalFees: number;
    premium: number;
    hideTotalFees?: boolean;
    hidePremium?: boolean;
}

const SlaFees: React.FunctionComponent<Props> = (props) => {
    const { hidePremium, hideTotalFees, homeState, totalFees, premium } = props;

    return (
        <Grid container spacing={2} style={{ margin: 0, width: '100%' }}>
            <Grid>
                <LabeledData title="Home State" value={`${homeState}`} />
            </Grid>
            {!hidePremium && (
                <Grid>
                    <Tooltip title={'may include broker commission additional to rated premium'}>
                        <LabeledData title="Total Premium" value={`${formatDollar(premium)}`} />
                    </Tooltip>
                </Grid>
            )}
            {!hideTotalFees && (
                <Grid>
                    <LabeledData title="Total Fees" value={`${formatDollar(totalFees)}`} />
                </Grid>
            )}
        </Grid>
    );
};

export default SlaFees;
